import { Link } from "@tanstack/react-router";

import LogoWL from "~/assets/logo_wl.svg";
import { Button } from "@workspace/web-ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@workspace/web-ui/components/dialog";

import { useBmiNormalWeightModal } from "../pages/welcome/store/use-bmi-normal-modal";

type BmiModalProps = {
    result: number;
}

export function BmiNormalModal({result} : BmiModalProps) {
  const { isOpen, close } = useBmiNormalWeightModal();
 

  function handleClose() {
    close();
  }

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-xs rounded-[24px] px-4 pb-8 pt-6 sm:max-w-sm sm:px-8 sm:pb-10 sm:pt-8 md:max-w-xl lg:px-[64px] lg:pb-[60px] lg:pt-[40px] xl:max-w-[700px]">
        <div
          className="flex shrink-0 items-center justify-center"
          aria-hidden="true"
        >
          <Link to="/" className="mx-auto mb-4 sm:mb-6 lg:mb-[24px]">
            <img src={LogoWL} alt="Proxymed logo" className="w-32 sm:w-auto" />
          </Link>
        </div>
        <div className="flex flex-col items-center gap-2 xl:mb-[48px]">
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold sm:text-3xl lg:text-[40px] xl:mb-[16px]">
            Your BMI is {result} (Normal Weight)
            </DialogTitle>
            <DialogDescription className="text-center text-base leading-[27px] sm:text-lg">
              <p>
              Your BMI is within the normal range. If you&apos;re looking for general wellness and fitness tips, we can help. However, this program is primarily for weight loss.
              </p>
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="mb-[24px]">
          <Button
            type="button"
            className="h-12 sm:h-[50px] lg:h-[57px]"
            fullWidth
            size="xl"
            onClick={handleClose}
          >
           Okay
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
